import {
  Button,
  ButtonGroup,
  FormHelperText,
  Grid,
  FormLabel,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";

import { FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import HelmetReact from "../../Components/Helmet";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomTextField from "../../Components/TextField";
import "./style.css";
import { useErrorHandler } from "../../hooks";
import {
  createFAQPageAction,
  getFooterPageAction,
  updateFooterPageAction,
  RemoveFAQ,
} from "../../Redux/Actions/FooterPageAction";
import MyEditor from "../../Components/MyEditor";
import DeleteIcon from "@mui/icons-material/Delete";

const FooterPage = () => {
  const { setMsgConfig } = useErrorHandler();
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState("PRIVACYPOLICY");
  const { loading, FAQ, FooterData } = useSelector((state) => state.FooterPage);

  useEffect(() => {
    dispatch(getFooterPageAction(selectedTab));
  }, [selectedTab]);

  const validationSchema = yup.object().shape({
    faq_list:
      selectedTab === "FAQ"
        ? yup.array().of(
            yup.object().shape({
              title: yup
                .string()
                .required("Title is required")
                .matches(
                  /^\S.*/,
                  "* This field cannot contain whitepaces at first letter"
                ),
              faq_description: yup
                .string()
                .required("Description is required")
                .matches(
                  /^\S.*/,
                  "* This field cannot contain whitepaces at first letter"
                ),
            })
          )
        : yup.array().optional(),
    description:
      selectedTab !== "FAQ"
        ? yup
            .string()
            .required("Please enter description")
            .matches(
              /^\S.*/,
              "* This field cannot contain whitepaces at first letter"
            )
        : yup.string().optional(),
  });

  return (
    <>
      <HelmetReact name="Footer Page" />

      <Box className="d-details-box">
        <ButtonGroup variant="text" aria-label="text button group">
          <Button
            className={`${selectedTab === "PRIVACYPOLICY" ? "active" : ""}`}
            onClick={() => {
              setSelectedTab("PRIVACYPOLICY");
            }}
          >
            PRIVACY POLICY
          </Button>

          <Button
            className={`${selectedTab === "FAQ" ? "active" : ""}`}
            onClick={() => {
              setSelectedTab("FAQ");
            }}
          >
            FAQ
          </Button>

          <Button
            className={`${selectedTab === "TERMS&CONDITIONS" ? "active" : ""}`}
            onClick={() => {
              setSelectedTab("TERMS&CONDITIONS");
            }}
          >
            TERMS & CONDITIONS
          </Button>
          <Button
            className={`${selectedTab === "COOKIEPOLICY" ? "active" : ""}`}
            onClick={() => {
              setSelectedTab("COOKIEPOLICY");
            }}
          >
            COOKIE POLICY
          </Button>
        </ButtonGroup>
        <Formik
          initialValues={{
            faq_list: (selectedTab === "FAQ" &&
              FAQ &&
              FAQ.length >= 1 &&
              FAQ.map((item) => ({
                title: item.title || "",
                faq_description: item.description || "",
                id: item.id || "",
              }))) || [{ title: "", faq_description: "", id: "" }],
            description:
              FooterData && FooterData.description
                ? FooterData.description
                : "",
          }}
          validationSchema={validationSchema}
          enableReinitialize={true}
          // Handle form submission
          onSubmit={(values) => {
            if (selectedTab !== "FAQ") {
              const payload = {
                Id: FooterData?.id,
                description: values.description,
              };
              dispatch(updateFooterPageAction(payload));
              setMsgConfig({
                alertOpen: true,
                message: "Data Added Succefully!!",
                severity: "error",
                autoHideDuration: 2000,
              });
            } else {
              if (values.faq_list && values.faq_list.length >= 1) {
                const payload = {
                  faq_list: JSON.stringify(values.faq_list),
                };
                dispatch(createFAQPageAction(payload));
                setMsgConfig({
                  alertOpen: true,
                  message: "Data Added Succefully!!",
                  severity: "error",
                  autoHideDuration: 2000,
                });
              }
            }
          }}
        >
          {({
            values,
            touched,
            errors,
            setFieldValue,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldTouched,
          }) => (
            <Form>
              {selectedTab === "FAQ" && (
                <FieldArray name="faq_list">
                  {(arrayHelpers) => (
                    <Box>
                      {selectedTab === "FAQ" &&
                        values.faq_list &&
                        values.faq_list.length >= 0 &&
                        values.faq_list.map((item, index) => (
                          <Box className={"innerbox"} key={index}>
                            <Box className="deleteicon" key={index}>
                              <Grid item xs={12}>
                                <>
                                  {values.faq_list &&
                                    values.faq_list.length > 1 && (
                                      <DeleteIcon
                                        onClick={() => {
                                          arrayHelpers.remove(index);
                                          values.faq_list &&
                                            values.faq_list.length &&
                                            values.faq_list[index].id &&
                                            dispatch(
                                              RemoveFAQ({
                                                id: values.faq_list[index].id,
                                              })
                                            );

                                          !loading &&
                                            setMsgConfig({
                                              alertOpen: true,
                                              message:
                                                "FAQ Deleted Successfully!",
                                              severity: "success",
                                              autoHideDuration: 2000,
                                            });
                                        }}
                                        sx={{ cursor: "pointer" }}
                                      />
                                    )}
                                </>
                              </Grid>
                            </Box>

                            <Grid item xs={12}>
                              <CustomTextField
                                fieldType="textInput"
                                name={`faq_list.${index}.title`}
                                label="Title"
                                placeholder={"Enter Title"}
                                fullWidth
                                required
                                value={values.faq_list[index].title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  touched?.faq_list?.[index]?.title &&
                                  errors?.faq_list?.[index]?.title
                                    ? true
                                    : false
                                }
                              />

                              {errors?.faq_list?.[index]?.title &&
                                touched?.faq_list?.[index]?.title && (
                                  <FormHelperText className="error_message">
                                    {errors?.faq_list?.[index]?.title}
                                  </FormHelperText>
                                )}
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Box
                                sx={{
                                  mt: 5,
                                  mb: 5,
                                  fontFamily: "Poppins, sans-serif",
                                }}
                              >
                                <MyEditor
                                  value={values.faq_list[index].faq_description}
                                  name={`faq_list.${index}.faq_description`}
                                  onChange={(data) => {
                                    setFieldValue(
                                      `faq_list.${index}.faq_description`,
                                      data
                                    );
                                  }}
                                />
                                {errors?.faq_list?.[index]?.faq_description &&
                                  touched?.faq_list?.[index]
                                    ?.faq_description && (
                                    <FormHelperText className="error_message">
                                      {
                                        errors?.faq_list?.[index]
                                          ?.faq_description
                                      }
                                    </FormHelperText>
                                  )}
                              </Box>
                            </Grid>
                          </Box>
                        ))}
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Box
                          sx={{
                            p: 3,
                            border: "2px dashed grey",
                            background: "#fff",
                            "&:hover": {
                              cursor: "pointer",
                            },
                          }}
                          onClick={() =>
                            arrayHelpers.push({
                              title: "",
                              faq_description: "",
                            })
                          }
                        >
                          <Box sx={{ mt: 1, textAlign: "center" }}>
                            <FormLabel className="add-btn">ADD MORE</FormLabel>
                          </Box>
                          <Box sx={{ textAlign: "center" }}>
                            <AddCircleOutlineIcon />
                          </Box>
                        </Box>
                      </Grid>
                    </Box>
                  )}
                </FieldArray>
              )}
              {selectedTab !== "FAQ" && (
                <Box>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box
                      sx={{
                        mt: 5,
                        mb: 5,
                        fontFamily: " Poppins, sans-serif",
                      }}
                    >
                      <MyEditor
                        value={values.description}
                        name="description"
                        onChange={(data) => {
                          setFieldValue("description", data);
                        }}
                      />
                      {errors?.description && touched?.description && (
                        <FormHelperText className="error_message">
                          {errors?.description}
                        </FormHelperText>
                      )}
                    </Box>
                  </Grid>
                </Box>
              )}

              <Grid item xs={12} sx={{ textAlign: "end" }}>
                <Button
                  sx={{
                    margin: "10px 0px",
                    background: "#000",
                    borderRadius: "70px",
                  }}
                  variant="contained"
                  onClick={handleSubmit}
                >
                  SAVE
                </Button>
              </Grid>
            </Form>
          )}
        </Formik>
        {/* )} */}
      </Box>
    </>
  );
};

export default FooterPage;
